import React, { useCallback, useState } from "react";
import { OrganizationServicesOffered } from "@common/types/organization";
import { ServicesFilterOverlay } from "@components/services/ServicesFilterOverlay";
import { useClientBulkActions } from "../../ClientBulkActions/useClientBulkActions";

interface ServicesActionProps {
    onSubmitCallback?: () => void;
}

export const ServicesAction: React.FC<ServicesActionProps> = ({
    onSubmitCallback,
}) => {
    const bulkActions = useClientBulkActions();
    const [selectedServices, setSelectedServices] = useState<
        OrganizationServicesOffered[]
    >([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleApply = useCallback(async () => {
        setIsSubmitting(true);
        const applyServices = async () => {
            await bulkActions.run({
                action: "services",
                value: selectedServices,
            });
            onSubmitCallback?.();
        };
        await applyServices().finally(() => {
            setIsSubmitting(false);
        });
    }, [bulkActions, selectedServices, onSubmitCallback]);

    return (
        <ServicesFilterOverlay
            selectedServices={selectedServices}
            onChange={setSelectedServices}
            applyButtonOnClick={isSubmitting ? undefined : handleApply}
        />
    );
};
